/**
 * Forms
 * -----------------------------------------------------------------------------
 *
 * Target all form elements and apply UND form classes except for:
 * - Site Search Form
 *
 * JS is being used because most, if not all, form elements are being generated
 * by plugins that don't allow us to add classes to them. At some point we may
 * choose to go down the CSS route.
 */



// Imports
const { Is } = require( '../helpers/index' ); 



/**
 * Apply proper UND CSS & HTML to radio/checkbox input.
 *
 * The DOM manipulation applied by this function is specific to what we see
 * being output by MailPoet 3. However, it has not been placed in the MailPoet 3
 * overrides file because that structure could be common enough that it will
 * apply to other WordPress form plugins. If that turns out to not be true, move
 * this function and its wrappers to the MailPoet 3 override file.
 * 
 * @param {jQuery} $collection jQuery collection of radio/checkbox elements.
 * @param {String} type        Input toggle type, can be one of `radio` or
 *                             `checkbox`.
 */
function toToggleInput( $collection, type ) {

  const $x = $collection
    .addClass( type + '__option' )
    .parent()
      .parent()
        .addClass( 'form__selections' )
        .wrapInner( '<fieldset/>' )
      .end()
      .removeClass( 'form__label' )
      .addClass( type + '__label' )
      .contents()
        .filter( ( i, node ) => Is.domText( node ) )
          .before( '<span/>' )
          .wrap( '<span></span>' );

}

/**
 * Wrapper function for radio elements.
 * 
 * @param {jQuery} $radios jQuery collection of radio elements.
 */
function toRadioInput( $radios ) {
  toToggleInput( $radios, 'radio' );
}

/**
 * Wrapper function for checkbox elements.
 * 
 * @param {jQuery} $checkboxes jQuery collection of checkbox elements.
 */
function toCheckboxInput( $checkboxes ) {
  toToggleInput( $checkboxes, 'checkbox' );
}



/**
 * Form Inputs
 * -----------------------------------------------------------------------------
 *
 * Notes 
 * 1. Keep an eye on non-form select styling (CSS class) changes. They could
 *    impact this.
 */

const $forms      = $( 'form:not(.search__form)' );
const $controls   = $forms.find( 'input[type="text"], input[type="email"], input[type="password"], input[type="url"], textarea, select' );
const $radios     = $forms.find( 'input[type="radio"]' );
const $checkboxes = $forms.find( 'input[type="checkbox"]' );
const $labels     = $forms.find( 'label' );
const $buttons    = $forms.find( 'button, input[type="submit"]' );



$labels.addClass( 'form__label' );
$controls.addClass( 'form__control' );
$buttons.addClass( 'button' );

toRadioInput( $radios );
toCheckboxInput( $checkboxes );



/**
 * Non-Form Selects
 * -----------------------------------------------------------------------------
 *
 * Notes
 * 1. Restricting styling modification to the main content area of the page and
 *    ignoring site header and footer for now.
 * 2. This will be applied to selects within a form as well if said form is a
 *    descendant of `.main`. Since it is adding a class that the form input
 *    styling JS is adding and not doing anything else, this will not be an
 *    issue.
 * 3. Keep an eye on form select styling (CSS class) changes. They could impact
 *    this.
 */

$( '.main select' ).addClass( 'form__control' ); /* 1, 2, 3 */